import { UserStatus } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import { Resources, useResource } from "Translations/Resources";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";
import { useMemo } from "react";

type ListItem = CodeListItem<UserStatus>;
type Result = Array<ListItem>;

const userTypeToUserStatuses: Record<AccessRoleCode, Array<UserStatus>> = {
  [AccessRoleCodes.Customer]: [
    UserStatus.Unknown,
    // UserStatus.InvitedWaitingForConfirmation,
    UserStatus.Active,
    UserStatus.WaitingForEmailConfirmation,
    UserStatus.Deactivated,
    UserStatus.BlockedFinances,
    UserStatus.Anonymous,
    // UserStatus.Onboarding,
    UserStatus.EmailConfirmed,
    // UserStatus.RoleSelection,
  ],
  [AccessRoleCodes.Merchant]: [
    UserStatus.Unknown,
    UserStatus.InvitedWaitingForConfirmation,
    UserStatus.Active,
    UserStatus.WaitingForEmailConfirmation,
    UserStatus.Deactivated,
    UserStatus.BlockedFinances,
    // UserStatus.Anonymous,
    UserStatus.Onboarding,
    // UserStatus.EmailConfirmed
    // UserStatus.RoleSelection,
  ],
  [AccessRoleCodes.Hunter]: [
    UserStatus.Unknown,
    UserStatus.InvitedWaitingForConfirmation,
    UserStatus.Active,
    UserStatus.WaitingForEmailConfirmation,
    UserStatus.Deactivated,
    // UserStatus.BlockedFinances,
    // UserStatus.Anonymous,
    UserStatus.Onboarding,
    // UserStatus.EmailConfirmed,
    // UserStatus.RoleSelection,
  ],
  [AccessRoleCodes.HunterPlus]: [
    UserStatus.Unknown,
    UserStatus.InvitedWaitingForConfirmation,
    UserStatus.Active,
    UserStatus.WaitingForEmailConfirmation,
    UserStatus.Deactivated,
    // UserStatus.BlockedFinances,
    // UserStatus.Anonymous,
    UserStatus.Onboarding,
    // UserStatus.EmailConfirmed,
    // UserStatus.RoleSelection,
  ],
  [AccessRoleCodes.Admin]: [
    // UserStatus.Unknown,
    // UserStatus.InvitedWaitingForConfirmation,
    UserStatus.Active,
    // UserStatus.WaitingForEmailConfirmation,
    UserStatus.Deactivated,
    // UserStatus.BlockedFinances,
    // UserStatus.Anonymous,
    // UserStatus.Onboarding,
    // UserStatus.EmailConfirmed,
    // UserStatus.RoleSelection,
  ],
  [AccessRoleCodes.AdminLite]: [UserStatus.Active, UserStatus.Deactivated],
  [AccessRoleCodes.Aml]: [
    // UserStatus.Unknown,
    // UserStatus.InvitedWaitingForConfirmation,
    UserStatus.Active,
    // UserStatus.WaitingForEmailConfirmation,
    UserStatus.Deactivated,
    // UserStatus.BlockedFinances,
    // UserStatus.Anonymous,
    // UserStatus.Onboarding,
    // UserStatus.EmailConfirmed,
    // UserStatus.RoleSelection,
  ],
  [AccessRoleCodes.Employee]: [
    UserStatus.InvitedWaitingForConfirmation,
    UserStatus.EmailConfirmed,
    UserStatus.Active,
    UserStatus.Deactivated,
  ],
  [AccessRoleCodes.CustomerOnboarding]: [
    // UserStatus.Unknown,
    // UserStatus.InvitedWaitingForConfirmation,
    UserStatus.Active,
    // UserStatus.WaitingForEmailConfirmation,
    UserStatus.Deactivated,
    // UserStatus.BlockedFinances,
    // UserStatus.Anonymous,
    // UserStatus.Onboarding,
    // UserStatus.EmailConfirmed,
    // UserStatus.RoleSelection,
  ],
  Disponent: [],
  Child: [],
};

export const useUserStatusList = (userType: AccessRoleCode | undefined) => {
  const { t } = useResource();

  return useMemo<Result>(() => {
    if (!userType) {
      return Object.entries(UserStatus).map<ListItem>(([key]) => ({
        code: key as UserStatus,
        name: t(Resources.Form.UserStatus[key as UserStatus]),
      }));
    }

    return userTypeToUserStatuses[userType].map<ListItem>((status) => ({
      code: status,
      name: t(Resources.Form.UserStatus[status]),
    }));
  }, [t, userType]);
};
